import {
  StackItem,
  UtilityText,
  FormField,
  InputStatusMessage,
  TextInput,
  ParagraphText,
} from '@leagueplatform/genesis-core';
import { useIntl } from '@leagueplatform/locales';
import { FormState } from 'components/onboarding-account-setup/types/onboarding-account-setup-types';
import { formatAuMobile } from 'components/onboarding-account-setup/utils/onboarding-account-setup.format';

export interface MobileNumberInputProps {
  value: FormState['mobileNumber'];
  onChange: (value: string) => void;
  error: FormState['mobileNumberError'];
  errorMessage?: string;
}

const renderParagraph = (chunk: React.ReactNode) => (
  <ParagraphText css={{ color: '$onSurfaceTextSubdued' }}>
    {chunk}
  </ParagraphText>
);

export const MobileNumberInput = ({
  value,
  onChange,
  error,
  errorMessage,
}: MobileNumberInputProps) => {
  const { formatMessage } = useIntl();
  const localisedError = error ? formatMessage({ id: error }) : null;
  const displayedError = errorMessage || localisedError;
  return (
    <StackItem css={{ gap: '$oneAndHalf' }}>
      <UtilityText emphasis="subtle">
        {formatMessage(
          { id: 'STR_ONBOARDING_ACCOUNT_SETUP_MOBILE_HELPER' },
          {
            p: renderParagraph,
          },
        )}
      </UtilityText>
      <FormField
        id="mobile-number"
        label={formatMessage({
          id: 'STR_ONBOARDING_ACCOUNT_SETUP_MOBILE_LABEL',
        })}
        name="mobile-number"
        inputStatus={displayedError ? 'error' : undefined}
        statusMessage={
          displayedError ? (
            <InputStatusMessage hideIcon>{displayedError}</InputStatusMessage>
          ) : null
        }
        required
      >
        <TextInput
          value={formatAuMobile(value)}
          onChange={(e) => onChange(formatAuMobile(e.target.value))}
          type="tel"
          inputMode="tel"
          autoComplete="tel"
          placeholder={formatMessage({
            id: 'STR_ONBOARDING_ACCOUNT_SETUP_MOBILE_PLACEHOLDER',
          })}
          css={{
            maxWidth: '75%',
            '@mobile': { maxWidth: 'unset' },
            '.GDS-base-input': { borderRadius: '$extraLarge' },
          }}
        />
      </FormField>
    </StackItem>
  );
};
